import { getSizedImageURL } from '../../core/images';

const initSelectedColorElementsInSticky = () => {
  // Add the correct product image
  $('[data-mobile-sticky-add-to-cart-image] [data-product-main]').remove();
  const first_image = $('[data-product-mobile-images] .product-main').first().find('img');
  const first_image_src_resized = getSizedImageURL(first_image.attr('src'), '500x', true);
  $('[data-mobile-sticky-add-to-cart-image]').append(`<div class="product-main" data-product-main><img class="product-main__image" src="${first_image_src_resized}" alt="${first_image.attr('alt')}" tabindex="0"></div>`);

  // No need to refresh the price, sizes, add to cart UNLESS a size has already been selected
  $('[data-mobile-sticky-add-to-cart-main] [data-product-option-size].active').trigger('click');
};

export default () => {
  // colors_only = true when "add to cart" has been clicked but no colors has been selected yet (sizes not showing)
  const openSizes = (colors_only = false) => {
    // Always active when opened
    $('[data-mobile-sticky-add-to-cart-sizes]').addClass('active');

    initSelectedColorElementsInSticky();

    // Trigger custom event for Fit Predictor widget
    // const pdp_mobile_sizes_opened = new CustomEvent('astr-pdp-mobile-sizes-opened', { bubbles: true });
    // document.dispatchEvent(pdp_mobile_sizes_opened);
    // document.addEventListener('astr-pdp-mobile-sizes-opened', (e) => {
    //  // Custom code
    // });
  };

  const closeComponent = () => {
    $('html').removeClass('mobile-sticky-add-to-cart-opened-colors');
    $('[data-mobile-sticky-add-to-cart-closed]').addClass('active');
    $('[data-mobile-sticky-add-to-cart-opened]').removeClass('active');
    $('[data-pdp-overlay]').removeClass('active');
    $('[data-mobile-sticky-add-to-cart-image] [data-product-main]').remove();
    $('[data-mobile-sticky-add-to-cart-fits]').empty();
    $('[data-mobile-sticky-add-to-cart-colors]').empty();
    $('[data-mobile-sticky-add-to-cart-sizes]').empty().removeClass('active');
    $('[data-mobile-sticky-add-to-cart-main]').removeAttr('style');
  };

  const initFits = () => {
    const container = document.querySelector('[data-mobile-sticky-add-to-cart-main]');

    if (container.querySelector('[data-product-option-fits]') === null) {
      return;
    }

    // Custom event captured in PlusSizes
    const pdp_sticky_mobile_fits_init = new CustomEvent('astr-pdp-sticky-mobile-fits-init', { bubbles: true });
    document.dispatchEvent(pdp_sticky_mobile_fits_init);
  };

  $(document).on('click touchend', '.sticky-add-to-cart--mobile .product-size-info', (e) => {
    e.stopPropagation();
    e.preventDefault();

    window.setTimeout(() => {
      let zindex = 999999;
      if ($('#INDWrap').length) {
        zindex = Number($('#INDWrap').css('z-index')) + 1;
      }

      $('.blocker').css('z-index', zindex);
    }, 10);
  });

  // Closes the sticky add to cart
  $(document).on('click touchend', '[data-pdp-overlay]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    closeComponent();
  });

  // Closes the sticky add to cart
  $(document).on('click', '[data-mobile-sticky-add-to-cart-close]', () => {
    closeComponent();
  });

  // Select a color
  $(document).on('click touchend', '[data-product-option-color-mobile-sticky]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    const $item = $(e.currentTarget);
    const color_handle = $item.data('color-handle');
    $(`[data-product-option-color][data-color-handle="${color_handle}"]`).trigger('click');
    $('[data-product-option-color-mobile-sticky]').removeClass('active');
    $item.addClass('active');

    // Open the size selection if not already opened
    // if (!$('[data-mobile-sticky-add-to-cart-sizes]').hasClass('active')) {
    //   openSizes();
    // }

    initSelectedColorElementsInSticky();
  });

  // Select a size
  $(document).on('click', '[data-mobile-sticky-add-to-cart-sizes].active li', (e) => {
    // if (e.type == 'touchend') {
    const $item = $(e.currentTarget);

    if ($item.hasClass('disabled')) {
      return;
    }

    $(`[data-product-details] [data-size-handle="${$item.data('size-handle')}"]`).trigger('click');
    $('[data-product-option-sizes][data-product-option-size]').removeClass('active');
    $item.addClass('active');
    $('[data-mobile-sticky-add-to-cart-button]').attr('disabled', false);

    // console.log('add to cart', $item.data('size-handle'));

    /*
    window.setTimeout(() => {
      $('[data-add-to-cart]').trigger('click');
    }, 10);

    window.setTimeout(() => {
      closeComponent();
    }, 10);
    */
  });

  // Add to cart
  $(document).on('click touchend', '[data-mobile-sticky-add-to-cart-button]', (e) => {
    const $item = $(e.currentTarget);

    if ($item.attr('disabled') === 'disabled') {
      return;
    }

    $('[data-add-to-cart]').trigger('click');

    window.setTimeout(() => {
      closeComponent();
    }, 1000);
  });

  // Open the Mobile sticky add to cart
  $(document).on('click touchend', '[data-mobile-sticky-add-to-cart]', (e) => {
    if (window.theme.breakpoints.current !== 'mobile' && window.theme.breakpoints.current !== 'tablet') {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    // const $item = $(e.currentTarget);

    // $('html, body').animate({ scrollTop: 0 }, 'fast');
    $('[data-mobile-sticky-add-to-cart-closed]').removeClass('active');
    $('[data-mobile-sticky-add-to-cart-opened]').addClass('active');
    $('[data-pdp-overlay]').addClass('active');

    // Fits element if any
    if ($('[data-option-fit]').length && $('[data-option-fit]').hasClass('active')) {
      const fits_html = $('[data-option-fit]').html();
      $('[data-mobile-sticky-add-to-cart-fits]').html(fits_html);
      $('[data-mobile-sticky-add-to-cart-fits]').addClass('active');

      initFits();
    } else {
      $('[data-mobile-sticky-add-to-cart-fits]').remove();
    }

    // Only show the colors part if not selected
    // const show_colors_only = $('[data-selected-color-label]').hasClass('unselected');
    // $('[data-mobile-sticky-add-to-cart-main]').height(200);

    $('html').addClass('mobile-sticky-add-to-cart-opened-colors');

    // Duplicate the color element data-option-color into data-mobile-sticky-add-to-cart-colors
    let colors_html = $('[data-option-color]').html();
    colors_html = colors_html.replaceAll('data-product-option-color', 'data-product-option-color-mobile-sticky');
    $('[data-mobile-sticky-add-to-cart-colors]').html(colors_html);
    
    // Clicking a size will automatically add the variant to the cart
    // const sizes_html = $('[data-sizes-sticky]').html();
    // $('[data-mobile-sticky-add-to-cart-sizes]').html(sizes_html);
    let sizes_html = $('[data-option-size]').html();
    sizes_html = sizes_html.replace('<div class="product-option__sizes" data-product-option-sizes="" tabindex="0" role="list">', '<ul class="product-option__sizes" tabindex="0" role="list" data-product-option-sizes-sticky>');
    sizes_html = sizes_html.replaceAll('<div class="product-option__size', '<li class="product-option__size--mobile');
    // sizes_html = sizes_html.replaceAll('product-option__size', '');
    sizes_html = sizes_html.replaceAll('</span></div>', '</span></li>');
    sizes_html = sizes_html.replace('</div>', '</ul>');
    $('[data-mobile-sticky-add-to-cart-sizes]').html(sizes_html);
    $('[data-mobile-sticky-add-to-cart-sizes] select').remove();
    $('[data-mobile-sticky-add-to-cart-sizes] .product-option__title').text('Choose your size');

    // Size guide
    // const $size_guide_html = $('.product-size-info').clone();
    // $('[data-mobile-sticky-add-to-cart-sizes] .product-option__title').after($size_guide_html);

    // "Don't see your size" Klaviyo widget
    const $klaviyo_html = $('.klaviyo-bis-trigger').clone();
    $('[data-mobile-sticky-add-to-cart-sizes]').append($klaviyo_html);

    openSizes();
  });

  // mobile-sticky-add-to-cart is not on the gift card pages
  $(window).on('scroll', _.debounce(() => {
    const $satc = $('[data-mobile-sticky-add-to-cart-main]');
    if (!$satc.length) {
      return;
    }

    // console.log($satc.offset().top, $('footer.shopify-section-group-footer-group').offset().top);

    // Show the mobile sticky add to cart when reaching the end of product-actions
    if ($(window).scrollTop() >= $('[data-product-details] .product-actions').offset().top + $('[data-product-details] .product-actions').outerHeight() - 100) {
      $satc.css('opacity', 1);
      $satc.attr('aria-hidden', false);
    } else {
      $satc.css('opacity', 0);
      $satc.attr('aria-hidden', true);
    }

    // Hide the mobile sticky add to cart when reaching the footer
    if ($satc.offset().top >= $('footer.shopify-section-group-footer-group').offset().top) {
      if (!$satc.hasClass('not-visible')) {
        $satc.addClass('not-visible');

        window.setTimeout(() => {
          // $satc.addClass('not-visible--none');
          $('.template-product main').css('z-index', 2);
        }, 250);
      }
    } else if ($satc.hasClass('not-visible')) {
      // $satc.removeClass('not-visible--none');
      $('.template-product main').css('z-index', 3);
      $satc.removeClass('not-visible');
    }
  }, 10));
};
